export const VALIDATION_REGEX = {
    buyer: /^[A-Za-z가-힣\s'-.]*$/,
    phoneNumber: /^(01[016789]{1})-?[0-9]{3,4}-?[0-9]{4}$/,
    orderTel: /^[0-9]*$/,
    orderNum: /^[A-Za-z0-9]+$/,
} as const;
